import { useState } from 'react';
import { styled } from 'styled-components';
import PurchaseTop10List from '../common/PurchaseTop10List';
import ReviewTop10List from '../common/ReviewTop10List';
import SectionTitle from '../common/SectionTitle';

export default function Top10ExperienceProductSection() {
  const [activeButton, setActiveButton] = useState<'review' | 'purchase'>('purchase');

  const handleButtonClick = (button: 'review' | 'purchase') => {
    setActiveButton(button);
  };

  return (
    <div>
      <SectionTitle title={'지금이 가장 재밌을 때'} slogan={'요즘 제일 HOT! 농어촌 놀거리'} />
      <ButtonWrapper>
        <StyledButton
          active={activeButton === 'purchase'}
          onClick={() => handleButtonClick('purchase')}>
          🔥 지금 인기 최고
        </StyledButton>
        <StyledButton
          active={activeButton === 'review'}
          onClick={() => handleButtonClick('review')}>
          👍 후기가 증명
        </StyledButton>
      </ButtonWrapper>
      {activeButton === 'review' && <ReviewTop10List />}
      {activeButton === 'purchase' && <PurchaseTop10List />}
    </div>
  );
}

const ButtonWrapper = styled.div`
  display: flex;
  gap: 10px;
  justify-content: center;
  margin-bottom: 20px;
`;

const StyledButton = styled.button<{ active?: boolean }>`
  padding: 10px 20px;
  border-radius: 20px;
  border: ${({ active, theme }) =>
    active ? `1px solid ${theme.colors.primary}` : '1px solid #ccc'};
  background-color: ${({ active, theme }) => (active ? theme.colors.primaryRGB : 'transparent')};
  color: ${({ active, theme }) => (active ? theme.colors.black : theme.colors.gray800)};
  cursor: pointer;
  font-size: 14px;
  transition:
    background-color 0.3s,
    color 0.3s;

  @media (hover: hover) {
    &:hover {
      background-color: ${({ active, theme }) => (active ? theme.colors.primary : '#f0f0f0')};
    }
  }
`;
